<template>
  <b-container class="card-container">

    <h4>Email whitelist</h4>
    <b-card no-body>
      <template v-slot:header>
        <div class='d-inline-block'>
          <b-input-group size='sm' class='mr-2' style='max-width: 250px'>
            <b-form-input placeholder='Email' v-model='email'></b-form-input>
            <b-input-group-append>
              <b-button @click="add_email_to_whitelist">Add</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </template>

      <b-table :items="email_whitelist" :fields="['email', 'created']">
        <template v-slot:cell(email)='data'>
          <a target="_blank" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Femail_whitelist~2F${data.item.id}`">{{data.value}}</a>
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
      </b-table>
    </b-card>
  </b-container>
</template>

<script>

import { db } from '@/main.js'
import api from '@/lib/api.js'

export default {
  metaInfo: {title: 'Admin'},
  data() {
    return {
      email_whitelist: [],
      email: '',
      loading: false
    }
  },
  firestore: function () {
    return {
      email_whitelist: db.collection('email_whitelist').orderBy('created', 'desc'),
    }
  },
  methods: {
    async add_email_to_whitelist() {
      let email = this.email.trim().toLowerCase()
      this.loading = true
      await db.collection('email_whitelist').doc(email).set({email: email, created: new Date()})
      this.loading = false
    }
  },
}
</script>

<style scoped>

</style>
